export const transformCloudinaryURL = (
  url: string,
  height = 720,
  width = 720
): string => {
  if (typeof url !== "string" || !url) {
    console.warn("transformCloudinaryURL called with invalid URL: ", url)
    return url
  }

  const parts = url.split("/upload/")
  if (parts.length < 2) {
    // This check ensures that the URL structure is as expected.
    // If not, handle accordingly (e.g., return the original URL or a default one).
    return url // Returning the original URL as a fallback.
  }

  const resUrl = parts[0] + `/upload/w_${width},h_${height},c_fill/` + parts[1]
  return resUrl
}
